
import { Component, Input, OnInit } from '@angular/core';
import { AppService } from '@core/services/app.service';
import { DownloadService } from '@core/services/download.service';
import { ErrorHandlerService } from '@core/services/errorHandler/error-handler.service';
import { UserManualService } from '@core/services/user-manual.service';
import { entitlements } from '@env/entitlements';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Spinner } from '@shared/models/spinner';
import { Application } from 'src/app/shared/models/Application';

import { SecurityService } from '../services/security.service';
import { EntitlementsModalComponent } from './entitlements-modal/entitlements-modal.component';
import { EntitlementsLoadedService } from '@core/services/entitlements-loaded.service';
import { StorageService } from '@core/services/storage.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit{
  @Input() application!: Application;
  public businessMonitoringEntitlement = [entitlements.VUS.FCSC_OPEN_SEARCH_DASHBOARD];
  public username!: string;
  public entitlementList: string[] = [];
  isLoading = false;
  loadingTitle!: string;
  loadingSubtitle!: string;
  spinnerObject!: Spinner;

  constructor(
    private readonly securityService: SecurityService,
    private readonly modalService: NgbModal,
    private readonly userManualService: UserManualService,
    private readonly downloadService: DownloadService,
    private readonly notificationService: ErrorHandlerService,
    private readonly appService: AppService,
    private readonly entitlementsLoadedService: EntitlementsLoadedService,
    private readonly storageService: StorageService
  ) {}

  ngOnInit() {
    this.spinnerObject = {
      loadingTitle: 'components.header.spinner.fetch-title',
      loadingSubtitle: 'components.header.spinner.fetch-subtitle',
      isLoading: false,
    };

    this.appService.spinnerSubject.subscribe((spinnerObject: Spinner) => {
      this.loadingTitle = spinnerObject.loadingTitle;
      this.loadingSubtitle = spinnerObject.loadingSubtitle;
      this.isLoading = spinnerObject.isLoading;
    });

    if (this.securityService.isLoggedIn()) {
      this.username = this.securityService.user.upn;
    }
    this.entitlementsLoadedService.usernameLoadedEvent$.subscribe(flag => {
      this.username = this.securityService.user.upn;
    });
  }

  public logout(): void {
    this.storageService.clearData();
    localStorage.clear();
    this.securityService.logout();
  }

  public getUserManual() {
    this.spinnerObject.isLoading = true;
    this.appService.spinnerSubject.next(this.spinnerObject);
    this.userManualService.getPresignedUrlForUserManualFiles().subscribe({
      next: (response: any) => {
        this.spinnerObject.isLoading = true;
        this.appService.spinnerSubject.next(this.spinnerObject);
        const url = response?.presignedUrl.toString();
        this.userManualService.getExportFileFromPresignedUrl(url).subscribe({
          next: (res: Blob) => {
            this.spinnerObject.isLoading = false;
            this.appService.spinnerSubject.next(this.spinnerObject);
            this.downloadService.downloadFile(res, 'user-manual.pdf');
          },
          error: (error) => {
            this.spinnerObject.isLoading = false;
            this.appService.spinnerSubject.next(this.spinnerObject);
            this.notificationService.handleServerErrorNotification(
              error,
              'components.header.usermanual-error-message'
            );
          }
        });
      },
      error: (error) => {
        this.spinnerObject.isLoading = false;
        this.appService.spinnerSubject.next(this.spinnerObject);
        this.notificationService.handleServerErrorNotification(
          error,
          'components.header.usermanual-error-message'
        );
      }
    });
  }

  public viewEntitlements(): void {
    this.entitlementList = this.securityService
      .getEntitlements()
      .filter((item) => item !== entitlements.VUS.FCSC_PUBLIC) as string[];
    const modalRef = this.modalService.open(EntitlementsModalComponent, {
      size: 'md',
      windowClass: 'entitlement-modal',
      backdrop: 'static',
      keyboard: false,
    });

    modalRef.componentInstance.entitlements = this.entitlementList;
  }

  navigateToBusinessMonitoring() {
    window.open(
      'https://os.monitor.vus.corpinter.net/_dashboards/app/dashboards#/view/cf830d00-35ad-11ed-a277-2d7b915b2ee6?_g=(filters:!(),refreshInterval:(pause:!t,value:0),time:(from:now%2Fd,to:now%2Fd))&_a=(description:%27%27,filters:!((%27$state%27:(store:appState),meta:(alias:!n,disabled:!f,index:%2791ff7a30-2e76-11eb-959a-afcd443d9629%27,key:useCase.keyword,negate:!f,params:(query:FCS-C.calculateFlashware),type:phrase),query:(match_phrase:(useCase.keyword:FCS-C.calculateFlashware)))),fullScreenMode:!f,options:(hidePanelTitles:!f,useMargins:!t),query:(language:kuery,query:%27%27),timeRestore:!f,title:%27FCS-C%20PROD%27,viewMode:view)',
      '_blank'
    );
  }
}
